jQuery(document).ready(function ($) {
  //##############################################//
  //###*****   Slick sliders
  //##############################################//

  // js-category-carousel nav-item
  $('.js-category-carousel .m-category-carousel__nav-item').each(function () {
    $('.js-category-carousel--nav').append($(this));
  });

  const mq = window.matchMedia('(min-width: 992px)');
  if (mq.matches) {
    $('.js-category-carousel').each(function () {
      $(this).slick({
        asNavFor: '.js-category-carousel--nav',
        dots: false,
        slide: '.m-category-carousel__item',
        arrows: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 0,
        centerPadding: '40px',
        fade: true,
        cssEase: 'linear',
        //appendArrows: ".c-slider--how-it-works__arrows",
      });
    });
    $('.js-category-carousel--nav').each(function () {
      $(this).slick({
        asNavFor: '.js-category-carousel',
        centerMode: false,
        slidesToShow: 8,
        autoplay: false,
        autoplaySpeed: 0,
        cssEase: 'linear',
        centerPadding: '20px',
        focusOnSelect: true,
        infinite: false,
        initialSlide: 0,
        arrows: true,
        dots: false,
      });
    });
    $('.js-category-carousel--nav').on(
      'mouseenter',
      '.slick-slide',
      function (e) {
        var $currTarget = $(e.currentTarget),
          index = $currTarget.data('slick-index'),
          slickObj = $('.js-category-carousel').slick('getSlick');

        slickObj.slickGoTo(index);
      }
    );
  } else {
    $('.js-category-carousel').each(function () {
      $(this)
        .not('.slick-initialized')
        .slick({
          arrows: false,
          dots: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 0,
          centerPadding: '0px',
          cssEase: 'ease-in-out',
          infinite: false,
          initialSlide: 0,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                arrows: false,
                dots: false,
                centerMode: false,
                centerPadding: '20px',
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                initialSlide: 0,
              },
            },
            {
              breakpoint: 820,
              settings: {
                arrows: false,
                dots: false,
                centerMode: false,
                centerPadding: '20px',
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                initialSlide: 0,
              },
            },
            {
              breakpoint: 640,
              settings: {
                arrows: false,
                dots: false,
                centerMode: false,
                centerPadding: '40px',
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                initialSlide: 0,
              },
            },
            {
              breakpoint: 340,
              settings: {
                arrows: false,
                dots: false,
                centerMode: true,
                centerPadding: '20px',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                initialSlide: 0,
              },
            },
          ],
        });
    });
  }

  // $(".js-upsell-carousel").each(function () {
  //   $(this).slick({
  //     dots: false,
  //     arrows: true,
  //     centerMode: false,
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     autoplay: false,
  //     autoplaySpeed: 0,
  //     centerPadding: "40px",
  //     cssEase: "ease-in-out",
  //     appendArrows: ".c-upsell-related__slider-arrows",
  //     responsive: [
  //       {
  //         breakpoint: 1200,
  //         settings: {
  //           arrows: true,
  //           dots: false,
  //           centerMode: false,
  //           centerPadding: "40px",
  //           slidesToShow: 3,
  //         },
  //       },
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           arrows: false,
  //           dots: false,
  //           centerMode: true,
  //           centerPadding: "40px",
  //           slidesToShow: 2,
  //         },
  //       },
  //       {
  //         breakpoint: 620,
  //         settings: {
  //           arrows: false,
  //           dots: false,
  //           centerMode: false,
  //           centerPadding: "70px",
  //           slidesToShow: 1,
  //         },
  //       },
  //       {
  //         breakpoint: 420,
  //         settings: {
  //           arrows: false,
  //           dots: false,
  //           centerMode: false,
  //           centerPadding: "20px",
  //           slidesToShow: 1,
  //         },
  //       },
  //     ],
  //   });
  //});
  // $(".js-crosssell-carousel").each(function () {
  //   $(this).slick({
  //     dots: false,
  //     arrows: true,
  //     centerMode: false,
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     autoplay: false,
  //     autoplaySpeed: 0,
  //     centerPadding: "40px",
  //     cssEase: "ease-in-out",
  //     appendArrows: ".c-crosssell-related__slider-arrows",
  //     responsive: [
  //       {
  //         breakpoint: 1200,
  //         settings: {
  //           arrows: true,
  //           dots: false,
  //           centerMode: false,
  //           centerPadding: "40px",
  //           slidesToShow: 3,
  //         },
  //       },
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           arrows: false,
  //           dots: false,
  //           centerMode: true,
  //           centerPadding: "40px",
  //           slidesToShow: 2,
  //         },
  //       },
  //       {
  //         breakpoint: 620,
  //         settings: {
  //           arrows: false,
  //           dots: false,
  //           centerMode: false,
  //           centerPadding: "70px",
  //           slidesToShow: 1,
  //         },
  //       },
  //       {
  //         breakpoint: 420,
  //         settings: {
  //           arrows: false,
  //           dots: false,
  //           centerMode: false,
  //           centerPadding: "20px",
  //           slidesToShow: 1,
  //         },
  //       },
  //     ],
  //   });
  // });
  $('.js-site-footer-slider').slick({
    draggable: true,
    dots: true,
    infinite: true,
    arrows: true,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: 'ease-out',
    appendArrows: '.m-image-content-slider__slider-arrows',
    speed: 600,
  });

  // //HP Text slider
  // $(".js-hp-hero-carousel--text").slick({
  //   draggable: true,
  //   dots: false,
  //   infinite: true,
  //   arrows: false,
  //   fade: true,
  //   autoplay: true,
  //   cssEase: "ease-out",
  //   //appendArrows: '.c-slider__arrows--image-slider',
  //   speed: 900,
  //   autoplaySpeed: 5000,
  // });

  // //Brand slider
  $('.js-brand-slider').slick({
    draggable: true,
    dots: true,
    appendDots: '.m-brand-slider__slider-dots',
    infinite: true,
    arrows: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: 'ease-out',
    speed: 600,
  });

  // //Blog featured slider
  $('.js-featured-post-slider').slick({
    dots: true,
    infinite: true,
    arrows: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    appendDots: '.js-featured-post-slider--dots',
    cssEase: 'cubic-bezier(0.330, 0.150, 0.660, 0.115)',
  });

  // //Homepage hero slider 2025
  $('.js-homepage-hero').slick({
    dots: false,
    infinite: true,
    arrows: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'cubic-bezier(0.330, 0.150, 0.660, 0.115)',
  });
});
